import { useQuery } from "@tanstack/react-query";

import { listActiveSubscriptions } from "@/platform/billing/api";
import type { PlatformSubscriptionRow, PlatformTenantSlug } from "@/platform/lib/database.types";

/**
 * Devolve assinaturas ativas da usuária autenticada (trialing | active | past_due).
 *
 * staleTime curto (10s) e refetch ao voltar pra aba garantem que o estado da
 * assinatura se atualiza rápido logo após o webhook de checkout ativar.
 */
export function useActiveSubscriptions() {
  return useQuery<PlatformSubscriptionRow[]>({
    queryKey: ["billing", "active-subscriptions"],
    queryFn: listActiveSubscriptions,
    staleTime: 10_000,
    refetchOnWindowFocus: true,
  });
}

/**
 * Conveniência: assinatura ativa de um tenant específico (ou null).
 */
export function useTenantSubscription(tenant: PlatformTenantSlug) {
  const query = useActiveSubscriptions();
  const subscription = query.data?.find((s) => s.tenant === tenant) ?? null;
  return {
    ...query,
    subscription,
    isActive: Boolean(subscription),
    isTrialing: subscription?.status === "trialing",
  };
}
